const { setCssVariables } = require("../../../../js/globalCssVariables");

window.addEventListener('UC_UI_INITIALIZED', function(event) {
    var style = document.createElement('style')
    style.innerHTML = `@media screen and (min-width: 0px) and (max-width: 768px) { [data-testid="uc-category-toggle"] { width: 100% }}`
    $('#usercentrics-root:first')[0].shadowRoot.appendChild(style)
});

$(function () {

    /****
     * BLOCKS and COMPONENTS
     */

    /*** ACCORDIANS 
     * preventDefault is used since the page is encapsulated by a form tag and the button triggers a form send... ****/
    $('button.accordion__toggle').click(function (e) {
        e.preventDefault()
    })

    //wait a bit and fix all widows
    $('main p, main h1, main h2, main h3').not('.ignore-widow').widont();

    //Custom dropdown init
    customDropdown.init(".custom-select-form", ".dropdown");

    $('.search-results__input').keydown(function (e) {
        if (e.keyCode == 13) {
            $('.search-results__submit').click();
            return false;
        }
    });

    $('.search-results__submit').click(function () {
        var searchString = $('.search-results__input').val();
        if (searchString) {
            window.location.href = window["sharedData"].SearchFormatString.replace("{0}", encodeURIComponent(searchString));
        }
        return false;
    });

    $('#main-search-box').keydown(function (e) {
        if (e.keyCode == 13) {
            var searchString = $('#main-search-box').val();
            if (searchString) {
                window.location.href = window["sharedData"].SearchFormatString.replace("{0}", encodeURIComponent(searchString));
            }
            return false;
        }
    });

    var random = Math.floor(Math.random() * $('.promo-banner').length);
    $('.promo-banner').eq(random).show();

    $('.find-an-etf__dropdown .dropdown-item').click(function (e) {
        $('#find-an-etf-dropdown').find('.dropdown__label').html($(this).text());
    });

    if (document.getElementsByClassName("flip-btn-url").length) {
        flip.flipBtn();
    }
})

/*Fix all widows*/
new function () { var n = { auto: function (n) { return null != n ? t.auto = n : t.auto }, init: function () { return t.init() }, transform: function (n) { return t.widont(n) } }; $.jqwidont = n; var t = { auto: !0, init: i, widont: function (n) { return n.replace(t.regexp, "&#160;$1") }, regexp: new RegExp("[\\n\\r\\s]+([^\\n\\r\\s(?:&#160;)]+[\\n\\r\\s]*)$", "m") }; function i() { } $(document).ready(function () { t.auto }), $.fn.widont = function () { return $(this).each(function () { var n = $(this); n.html(t.widont(n.html())) }) } };


/****
 * CUSTOM DROPDOWNS FOR FORMS***
 */
window.customDropdown = {
    init: function (form, dropClass) {
        $(form).find(dropClass).each(function () {
            customDropdown.addDropdown($(this)); // Add dropdowns
            customDropdown.dropdownEventHandler($(this)); //Dropdown event handler
        });
    },
    dropdownEventHandler: function (dropWrap) {
        dropWrap.find(".dropdown-item").click(function () {
            customDropdown.changeSelector(dropWrap.find("select"), $(this).attr("value"));
            console.log(dropWrap.find(".dropdown__button span"), "text");
            dropWrap.find(".dropdown__button span").text($(this).text());
            //dropWrap.find(".dropdown__button").attr("data-value", $(this).attr("value"));
        });
    },
    changeSelector: function (dropdown, selectedVal) {
        dropdown.find("option").removeAttr("selected");
        dropdown.find("option").each(function () {
            if ($(this).attr('value') == selectedVal) {
                $(this).attr("selected", "selected");
                $(this).prop("selected", true);
                dropdown.val(selectedVal).change();
                $(dropdown).prop("value", selectedVal).trigger('customDropdownChange');
            }
        });
    },
    addDropdown: function (dropWrap) {
        var _html = '';
        var selectElm = dropWrap.find("select");

        // IE fix
        selectElm.find('[data-f-default-value]').attr("selected", "selected");

        _html += '<button aria-haspopup="true" aria-expanded="false" data-value="' + selectElm.find("option:selected").val() + '" class="dropdown__button dropdown__button-default text-util-sm" data-toggle="dropdown" id="example-dropdown" type="button">';
        _html += '<span class="dropdown__label" >' + selectElm.find(":selected").text() + '</span >';
        _html += '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="chevron-down" class="svg-inline--fa fa-chevron-down fa-w-16 fa-2x dropdown__icon dropdown__icon-default" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">';
        _html += '<path fill="currentColor" d="M2.26 4.88a.75.75 0 00-.54.21.75.75 0 000 1.07l6.75 6.75a.75.75 0 001.06 0l6.75-6.75a.75.75 0 000-1.07.75.75 0 00-1.06 0L9 11.31 2.78 5.1a.75.75 0 00-.52-.21z"></path>';
        _html += '</svg></button>';

        _html += '<div class="dropdown-menu dropdown__menu text-util-sm" role="menu">';

        selectElm.find("option").each(function () {
            _html += '<button class="dropdown-item dropdown__item text-util-sm" role="menuitem" type="button" value="' + $(this).val() + '">' + $(this).text() + '</button>';
        });

        _html += "</div>";

        selectElm.hide();
        dropWrap.append(_html);

    }
}



/****
 * VIEWPORT WIDE SPINNER ***
 */
window.viewportWideSpinner = {
    //A spinner that will be centered on the screen in a translucent background. Removes all other spinners around so forms will only use this one.

    init: function () {
        //Remove all instances of spinners inside any existing form. We want this one to be authoritative!
        $('form > #veSpinnerContainer, :not(#viewport-wide-spinner) > #veSpinnerContainer').remove();
        //Not initialised by Default, will be initiaised only once the component is added to the page.
    }
}



/*** Homepage ***/
/* Show the hero banners once the page has loaded */
$('main > div.compound-hero').removeClass('d-none');

window.addEventListener('load',
    function () {
        /* Fix BS4 bug where active class is not removed. Listener must be load to run after std BS4 bindings.*/
        $("body.home-page .ticker-nav__tabs .nav-tabs .nav-link").on('shown.bs.tab', function (e) {
            $("body.home-page .ticker-nav__tabs .nav-tabs .nav-link").removeClass('active');
            console.info("BS4 event captured and responded to.");
            $(e.currentTarget).addClass('active');
            //reset the expandable toggle so it is collapsed when switching tabs.
            $('#ticker-nav-ticker-nav-mfTabId-tab-collapsed-tab, #ticker-nav-ticker-nav-etfTabId-tab-collapsed-tab').tab('show')
        });

        /* Detect prices component to see if they are expanded and add an appropriate class.*/
        $('.ticker-nav__toggle').on('shown.bs.tab', function (e) {
            if (e.target.id.indexOf("expanded") > -1) { $('.tabs.ticker-nav__tabs').addClass("expanded"); return; }
            $('.tabs.ticker-nav__tabs').removeClass("expanded");
        });

        setCssVariables();
    });

/*** Apparel Page and other interactive image cards - Transition the background image ***/
$('.interactive-image.card').hover(function () {
    $(this).attr("data-image-original", ($(this).find(".interactive-image__image").css("background-image")));
    const template = $(this).data('content');
    const image = $(template).attr('src');
    $(this).css("background-image", "url(" + image + ")");
}, function () {
    $(this).css("background", "none");
});

/* support lazy loading on home-page slider */
$(".slider-for, .carousel-block__main--desktop").on("lazyLoadError", function (e, slick, image, imageSource) {
    parentSlide = $(image).parent(".compound-hero__bg, .insight-card__image");
    src = image.data("src"); //get source
    parentSlide.css("background-image", 'url("' + src + '")').addClass("loaded"); //replace with background instead
    image.remove();
});

const banner = document.getElementById('video-banner');
const bannerContainer = document.getElementById('video-banner-container');
if (banner) {
    function setVideoBanner(data) {
        let vData;
        vData = banner.getAttribute(data);
        vData !== undefined && banner.setAttribute("src", vData);
        bannerContainer.load();
    }
    ($(window).width() <= 480) ? setVideoBanner("data-mobilesource") : setVideoBanner("data-desktopsource");
}

var flip = {
    flipBtn: function () {
        var baseUrl = new URL(window.location.href);
        var redirectUrl = baseUrl.searchParams.get("url");
        document.getElementsByClassName("interstitial-view-btn")[0].href = redirectUrl;
    }
}

//SHOPIFY JAVASCRIPT
var vaneck = (function (module, $) {
    module.shopify = {
        waitUntilSelectorExists: function (selector, callback, intervalInMiliseconds) {
            intervalInMiliseconds = intervalInMiliseconds || 200;
            var checkExist = setInterval(function () {
                if ($(selector).length) {
                    clearInterval(checkExist);
                    callback();
                }
            }, intervalInMiliseconds);
        },
        getIframeStyleTagWhenLoaded: function (callback) {
            var iframe = '.shopify-buy-frame--productSet > iframe';
            vaneck.shopify.waitUntilSelectorExists(iframe, function () {
                var checkExist = setInterval(function () {
                    var $style = $(iframe).contents().find('style');
                    if ($style.length) {
                        clearInterval(checkExist);
                        callback($style);
                    }
                }, 200);
            });

        },
        applyCssOverrides: function (cssStyleOverrides) {
            $(document).ready(function () {
                var head = $('.shopify-buy-frame--productSet > iframe').contents().find('head');
                var css = 'h1 {color: red !important!}';
                var style = document.createElement('style');

                head.append(style);
                style.type = 'text/css';

                if (style.styleSheet) {
                    // This is required for IE8 and below.
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(document.createTextNode(css));
                }
            })
        }
    };

    return module;
}(vaneck || {}, jQuery));

var shopifyEvent;
if (typeof (Event) === 'function') {
    shopifyEvent = new Event('overidejs-loaded');
} else {
    shopifyEvent = document.createEvent('Event');
    shopifyEvent.initEvent('overidejs-loaded', true, true);
}

document.dispatchEvent(shopifyEvent);

// Print article page
$('.share-widget .print').on('click', function () {
    $('.share-widget').removeClass('show');
    $('.share-widget__menu').removeClass('show');
    window.print();
});
